import React, { memo } from "react";
import { JokerB } from "../../../../styles/images/SuitsImgBordered";
import {
  Clover,
  Heart,
  Pikes,
  Tiles,
} from "../../../../styles/images/SuitsImgWthoutBorder";

import "./gameResults.scss";
import {useTranslation} from "react-i18next";

function GameResults({ resultsData }) {
  const {t} = useTranslation();
  const suitsImg = [<JokerB />, <Clover />, <Heart />, <Pikes />, <Tiles />];

  return (
    <div className="results-delux">
      <div className="latest-results-dlx">
        <div className="latest-results-dlx-title">
          <h3>{t('last 5')}</h3>
        </div>

        <div className="latest-five-results">
          {resultsData
            ? resultsData?.latest_results.map((item, i) => (
                <>
                  <div className="box">
                    <span className={item.color}>
                      {item.number}
                    </span>
                    <span className="round-numbers"># {item.round}</span>
                    <span className="suits">
                      {suitsImg[resultsData?.latest_suit_results[i].number]}
                    </span>
                  </div>
                </>
              ))
            : null}
        </div>

        <div className="latest-results-dlx-title">
          <h3>{t('last 120')}</h3>
        </div>

        <div className="latest-draws-dlx">
          <h3 className="latest-draws-dlx-title">{t('colors')}</h3>
          <div className="latest-draws-dlx-colors-number">
            {resultsData
              ? resultsData.latest_draws.map((item) => (
                  <>
                    <span>{item.count}</span>
                  </>
                ))
              : null}
          </div>

          <h3 className="latest-draws-dlx-title">{t('sector')}</h3>

          <div className="sector-numbers">
            {resultsData
              ? resultsData.sector.map((item) => (
                  <div>
                    <span>{item.name}</span>
                    <span>{item.count}</span>
                  </div>
                ))
              : null}
          </div>

          <div className="dozens">
            <h3 className="latest-draws-dlx-title">{t('dozens')}</h3>
            <div>
              {resultsData
                ? resultsData.dozens.map((item) => (
                    <>
                      <span>{item.name}</span>
                      <span>{item.count}</span>
                    </>
                  ))
                : null}
            </div>
          </div>

          <div className="even-odd">
            <h3 className="latest-draws-dlx-title">{t('even odd')}</h3>
            <div>
              {resultsData
                ? resultsData.even_odd.map((item) => (
                    <>
                      <span>{item.name}</span>
                      <span>{item.count}</span>
                    </>
                  ))
                : null}
            </div>
          </div>

          <div className="under-over">
            <h3 className="latest-draws-dlx-title">{t('under over')}</h3>
            <div>
              {resultsData
                ? resultsData.over_under.map((item) => (
                    <>
                      <span>{item.name}</span>
                      <span>{item.count}</span>
                    </>
                  ))
                : null}
            </div>
          </div>

          <div className="suits-joker">
            <h3 className="latest-draws-dlx-title">{t('suits joker')}</h3>
            <div className="suits-joker-results">
              {resultsData
                ? resultsData.suits.map((item) => (
                    <div key={item.name}>
                      {suitsImg[Number(item.name)]}
                      <span>{item.count}</span>
                    </div>
                  ))
                : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(GameResults);
